// Label.js
import React from 'react';

export const Label = ({ children, className = '' }) => {
    return (
        <label className={`text-xs font-semibold text-gray-400 uppercase tracking-wider font-orbitron ${className}`}>
            {children}
        </label>
    );
};
